import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
        line-height: 1.5rem;
        letter-spacing: -0.5px;
    }

    h1 { 
        margin: 0;
    }
`;

export default GlobalStyle;
